import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Divider, FormControlLabel, Grid, Typography } from '@material-ui/core';
import { observer } from 'mobx-react';

import { Select } from 'core/components/select';
import useSession from 'core/hooks/use-session';
import { Collapsible } from '../collapsible';

const simulateSourceOptions = [
  { id: '', value: 'None (default Staff behavior)' },
  { id: 'apiRC1', value: 'API (RC1)' },
  { id: 'apiRC3', value: 'API (RC3)' }
];

const noHitDataPullOptions = [{ value: 'coverageVerifier', label: 'Coverage Verifier (CV)' }];

const ScenarioSimulationTools = observer(({ simulationConfig, onSourceChange, onToggleNoHitDataPull }) => {
  const { canSimulateSource } = useSession();

  if (!canSimulateSource) {
    return null;
  }

  return (
    <Collapsible initialOpen={false} title="Scenario Simulation Tools">
      <Grid container direction="column" spacing={2}>
        <Grid item xs={4}>
          <Select
            id="simulationSource"
            name="simulationSource"
            label="Simulate Source"
            mode="light"
            value={simulationConfig.source || ''}
            options={simulateSourceOptions}
            onChange={(_name, value) => onSourceChange(value)}
            fullWidth
          />
        </Grid>
        <Grid item>
          <Divider />
        </Grid>
        <Grid item>
          <Typography variant="subtitle2">Simulate no-hit on data pulls</Typography>
          {noHitDataPullOptions.map(({ value, label }) => (
            <FormControlLabel
              key={value}
              control={
                <Checkbox
                  checked={simulationConfig.noHitDataPulls.includes(value)}
                  onChange={() => onToggleNoHitDataPull(value)}
                />
              }
              label={label}
            />
          ))}
        </Grid>
      </Grid>
    </Collapsible>
  );
});

ScenarioSimulationTools.propTypes = {
  simulationConfig: PropTypes.shape({
    source: PropTypes.string,
    noHitDataPulls: PropTypes.arrayOf(PropTypes.string)
  }).isRequired,
  onSourceChange: PropTypes.func.isRequired,
  onToggleNoHitDataPull: PropTypes.func.isRequired
};

export default ScenarioSimulationTools;
